import Vue from 'vue'

const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	skills : [],
	current_skill : null,
}

const getters = {
	fetchSkills : (state) => state.skills,
	fetchCurrentSkill : (state) => state.current_skill,
}

const actions = {
	loadSkills({commit}, {token, filter, do_commit=true}){
		const query_arr = []
		for(let key in filter){
			if(filter[key]){
				query_arr.push(`${key}=${encodeURIComponent(filter[key])}`)	
			}
		}
		const query_str = query_arr.join('&')
		return $http.get(`skill?${query_str}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			if(do_commit){
				commit('SET_SKILLS', response.data)
			}else{
				return response
			}
		})
	},

	loadSkillDetails({commit}, {id, token}){
		return $http.get(`skill/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_SKILL', response.data)
		})
	},

	createSkill({commit}, {skill, token}){	
		return $http.post('skill', skill, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_SKILL', response.data)
		})
	},

	copySkill(obj, {copy, token}){	
		return $http.post('skill/copy', copy, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		})
		// .then((response) => {
		// 	commit('COPY_SKILL', response.data)
		// })
	},

	updateSkill({commit}, {id, skill, token}){
		
		return $http.put(`skill/${id}`, skill, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_SKILL', response.data)
		})
	},

	deleteSkill({commit}, {id, token}){
		return $http.delete(`skill/${id}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then(() => {
			commit('REMOVE_SKILL', id)	
		})
	},
}

const mutations = {
	SET_SKILLS : (state, skills) => {
		state.skills = skills
	},
	SET_CURRENT_SKILL : (state, skill) => {
		state.current_skill = skill
	},
	ADD_SKILL : (state, skill) => {
		state.skills.push(skill)
	},
	UPDATE_SKILL : (state, skill) => {
		state.current_skill = skill
		const sIndex = state.skills.findIndex(s => s._id === skill._id)
		Vue.set(state.skills, sIndex, skill)
	},
	// COPY_SKILL : (state, skill) => {
	// 	// Checking if 1st skill in the list 
	// },
	REMOVE_SKILL : (state, skill_id) => {
		state.skills = state.skills.filter(skill => skill._id != skill_id)
	},
}

export default {
	state, getters, actions, mutations
}